import {
	useCallback as hauntedUseCallback,
	useEffect as hauntedUseEffect,
	useLayoutEffect as hauntedUseLayoutEffect,
	useMemo as hauntedUseMemo,
	useRef as hauntedUseRef,
	useState as hauntedUseState,
} from "haunted";

export const useState = hauntedUseState;
export const useMemo = hauntedUseMemo;
export const useRef = hauntedUseRef;
export const useCallback = hauntedUseCallback;
export const useLayoutEffect = hauntedUseLayoutEffect;

export const useEffectWithoutCleanup = (
	callback: () => Promise<(() => void) | void> | ((() => void) | void),
	values?: unknown[] | undefined
): void =>
	hauntedUseEffect(() => {
		// setTimeout is used, because useEffect can cascade between embedded
		// components and can cause an update skipped (such as an "initial render")
		window.setTimeout(() => {
			const result = callback();
			if (result instanceof Promise) {
				result.catch(async (reason) => {
					// eslint-disable-next-line no-console
					console.log(reason);
				});
			}
		}, 0);
	}, values);

export const useEffectWithCleanup = hauntedUseEffect;
